import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "src/dm/utils/axios";

// Backs /admin/load-failed-deals — lists deals stuck in LOADFAILED and lets
// an admin Approve or Review each one. Mirrors legacy
// Admin/ManageLoadFailedDeals.aspx.

const baseUrl = "/dm/V1/admin/load-failed-deals";

export interface LoadFailedDealRow {
  dealId: number;
  description: string | null;
  status: string | null;
  statusDate: string | null;
  ownerUserId: string | null;
}

interface ListResponse {
  items: LoadFailedDealRow[];
  total: number;
}

export const useLoadFailedDeals = () =>
  useQuery({
    queryKey: ["admin-load-failed-deals"],
    queryFn: async (): Promise<LoadFailedDealRow[]> => {
      const response = await apiClient.get<ListResponse>(baseUrl);
      return response.data.items ?? [];
    },
  });

export type LoadFailedDealAction = "approve" | "review";

export interface LoadFailedDealActionResult {
  dealId: number;
  action: string;
  appliedStatus: string | null;
  changedAt: string;
}

export const useActOnLoadFailedDeal = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (req: {
      dealId: number;
      action: LoadFailedDealAction;
    }): Promise<LoadFailedDealActionResult> => {
      const response = await apiClient.post<LoadFailedDealActionResult>(
        `${baseUrl}/${req.dealId}/${req.action}`
      );
      return response.data;
    },
    onSuccess: () => {
      // Refresh the failed-deals grid so the row drops out of the list.
      qc.invalidateQueries({ queryKey: ["admin-load-failed-deals"] });
    },
  });
};
